import script from "./FunctionalLocationTree.vue?vue&type=script&lang=ts&setup=true"
export * from "./FunctionalLocationTree.vue?vue&type=script&lang=ts&setup=true"

import "./FunctionalLocationTree.vue?vue&type=style&index=0&id=363d983c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-363d983c"]])

export default __exports__